module.exports = __webpack_public_path__ + "static/media/intro.81aab67d.mp3";